import { ourServices } from "../../utilities/homeData";
import Button from "../button";
import ServiceCard from "./srviceCard";

const ServiceCards = () => {
  return (
    <div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4">
        {ourServices.map((item, index) => {
          return (
            <ServiceCard
              key={index}
              index={index}
              discription={item.discription}
              icon={item.icon}
              title={item.title}
            />
          );
        })}
      </div>

      <div className="mt-10 flex w-full justify-center">
        <Button href={"/services"}>
          <span className="px-10">View All Services</span>
        </Button>
      </div>

      {/* <motion.div
        whileHover={{
          scale: 1.1,
          cursor: "pointer",
          transition: { type: "spring", stiffness: 400, damping: 15 },
        }}
      >
        <NavLink
          to={"/services"}
          className="m-auto mt-10 block w-fit rounded-sm bg-visOrange px-10 py-3 text-sm font-semibold text-white lg:px-20 lg:text-[16px] lg:leading-[26px]"
        >
          View All Services
        </NavLink>
      </motion.div> */}
    </div>
  );
};

export default ServiceCards;
